module.exports = __webpack_public_path__ + "static/media/trash.e64210f3.png";